import { useLocation } from 'react-router-dom';
import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Chip from '@material-ui/core/Chip';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CmtList from '../../../@coremat/CmtList';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import parse from 'html-react-parser';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import { IntlProvider, useIntl } from 'react-intl';
import { injectIntl } from 'react-intl';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import { LinearProgress } from '@material-ui/core';
import { myFormatDate2, myFormatPrice, getMyDate2, getMyDate3 } from '../../../@jumbo/utils/commonHelper';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import Invoice from './Invoice';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#0063B1',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {},
}))(TableRow);

function getColor(x) {
  if (x == 0) return '#9DC63A';
  if (x == 1) return '#F1C01C';
  if (x == 2) return '#C63A3A';
  if (x == 3) return '#8E8CD8';
  if (x == 4) return '#c58cd8';
}

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  cardRoot: {
    position: 'relative',
  },
  root: {
    flexGrow: 1,
  },
  hotelSelect: {
    width: '100%',
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: '100px',
  },

  cardContentInner2: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
  },

  scrollbarRoot: {
    height: '100%',
    marginRight: -24,
    paddingRight: 24,
    marginLeft: -24,
    paddingLeft: 24,
    marginTop: -5,
    paddingTop: 5,
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Invoices extends React.Component {
  constructor(props) {
    super(props);
    var myhotelid = 0;
    var date2 = new Date();
    var date1 = new Date();
    date1.setDate(date2.getDate() - 30);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      date1: date1,
      running2: false,
      mode: '',
      hotelId: myhotelid,
      date2: date2,
      viewInvoiceVisible: false,
      setStatus: 0,
      userActivities: [],
    };
    this.updateActivities = this.updateActivities.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.eventClick = this.eventClick.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.doRefresh = this.doRefresh.bind(this);
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    setCurrentPage(intl.formatMessage({ id: 'pages.bookings' }));
    const { currentApplication, setCurrentApplication } = this.context;
    setCurrentApplication(1);

    this.updateActivities();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
    this.setState({ page: 0 });
  };

  doRefresh() {
    this.updateActivities();
  }

  handleChange(name, value) {
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  handleCustomChange(event, owner) {
    this.setState({ [owner]: event.target.value }, () => {
      //            this.updateRooms();
    });
  }

  handleChangePage(event, newPage) {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
    this.setState({ page: 0 });
  };

  checkDates() {
    if (this.state.date2 == null || Number(this.state.date2) <= Number(this.state.date1)) {
      var newdate = new Date(this.state.date1);
      newdate.setDate(newdate.getDate() + 1);
      this.setState({ date2: newdate });
    }
  }

  updateActivities() {
    if (this.state.date1 == null || this.state.date2 == null) return;
    var mydate1 = getMyDate(this.state.date1);
    var mydate2 = getMyDate(this.state.date2);
    const token = localStorage.getItem('token');
    var senddata = {};
    senddata = {
      Action: 'getInvoices',
      token: token,
      Version: 1,
      Data: {
        HotelId: this.state.hotelId,
        fromDate: mydate1,
        toDate: mydate2,
        searchStatus: this.state.searchStatus,
        searchClientName: this.state.searchClientName,
      },
    };

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
      const self = this;
      //   const intl = useIntl();
      const data = res.data.Data;
      const myactivities = [];
      if (data != null) {
        data.forEach(
          function(item, index) {
            var newitem = {};
            newitem.id = item['id'];
            newitem.ID = item['label'];
            newitem.cancel_id = item['cancel_id'];
            newitem.createdDate = getMyDate3(item['datetime2'], this.props.auth.authUser.language);
            newitem.mystatus = 0;
            var status = item['status'];
            var mystatus = '';
            if (status == 0) {
              mystatus = <IntlMessages id="invoice.statusVoid" />;
              newitem.mystatus = 1;
            }
            if (status == 1) {
              mystatus = <IntlMessages id="invoice.statusPaid" />;
              newitem.mystatus = 0;
            }
            if (item['cancel_id'] != null) {
              mystatus = <IntlMessages id="invoice.statusCancelled" />;
              newitem.mystatus = 2;
            }

            var sc = getColor(newitem.mystatus);
            newitem.status = [];
            newitem.status.push(
              <Chip
                label={mystatus}
                style={{ color: '#ffffff', fontWeight: 'bold', borderRadius: 2, backgroundColor: sc }}
              />,
            );

            newitem.total =
              myFormatPrice(parseFloat(item['total']), this.props.auth.authUser.numberMode) + ' ' + item['currency'];
            newitem.clientName = item['name'];
            var myhotelname = '';
            myhotelname = self.props.auth.authUser.hotels.find(({ id }) => id === item['hotel_id']).name;
            //myhotelname = item['hotel_id'];
            newitem.hotelName = myhotelname;
            myactivities.push(newitem);
          }.bind(this),
        );
        this.setState({ userActivities: myactivities });
        this.setState({ running2: false });
      }
    });
  }

  eventClick(args, args2, args3) {
    //    setOpenRes(true);
    if (args == 'createInvoice') {
      this.setState({ mode: 'create', selInvoiceId: '', selInvoiceTitle: '', viewInvoiceVisible: true });
    } else if (args == 'download') {
      if (this.state.date1 == null || this.state.date2 == null) return;
      var mydate1 = getMyDate(this.state.date1);
      var mydate2 = getMyDate(this.state.date2);
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'downloadcsv',
        token: token,
        Version: 1,
        Data: {
          HotelId: this.state.hotelId,
          fromDate: mydate1,
          toDate: mydate2,
          searchStatus: this.state.searchStatus,
        },
      };
      const config = { responseType: 'blob' };
      const filename = 'Invoices ' + getMyDate(this.state.date1) + '-' + getMyDate(this.state.date2) + '.csv';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    } else if (args == 'filter') {
      this.updateActivities();
    } else {
      this.setState({
        mode: 'view',
        selInvoiceId: args,
        setStatus: args3,
        selInvoiceTitle: args2,
        viewInvoiceVisible: true,
      });
    }
    //alert(this.state.selReservationId);
  }

  render() {
    const columns = [
      { id: 'createdDate', label: <IntlMessages id="invoice.createdDate" />, minWidth: 170 },
      {
        id: 'ID',
        label: <IntlMessages id="invoice.label" />,
        minWidth: 170,
        align: 'left',
      },
      {
        id: 'clientName',
        label: <IntlMessages id="invoice.clientName" />,
        minWidth: 170,
        align: 'center',
      },

      {
        id: 'hotelName',
        label: <IntlMessages id="bookings.property" />,
        minWidth: 170,
        align: 'left',
      },
      {
        id: 'status',
        label: <IntlMessages id="invoices.searchStatus" />,
        minWidth: 170,
        align: 'left',
      },

      {
        id: 'total',
        label: <IntlMessages id="res.total" />,
        minWidth: 170,
        align: 'right',
      },
    ];

    /*
       <Box className={classes.cardContentInner}>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('createInvoice')}>
                    <IntlMessages id="invoices.createInvoice" />
                  </Button>
                </FormControl>
              </Box>
     */
    const { classes } = this.props;
    var actionTitle = '';
    var hotels = this.props.auth.authUser.hotels;
    const myDate = new Date();
    var dateDisplay = myDate.toISOString().split('T')[0];
    return (
      <PageContainer heading={actionTitle}>
        <Paper className={classes.root}>
          {this.props.match.params.id == null && (
            <>
              <Box className={classes.cardContentInner}>
                {this.state.running2 && <LinearProgress />}

                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    id="hotelid"
                    name="hotelid"
                    label={<IntlMessages id="bookings.selectHotel" />}
                    margin="normal"
                    select
                    defaultValue=""
                    value={this.state.hotelId}
                    onChange={event => this.handleChange('hotelId', event.target.value)}>
                    <MenuItem value={0}>
                      <IntlMessages id="invoices.allProperties" />
                    </MenuItem>
                    {hotels.map((t, idx) => (
                      <MenuItem value={t.id}>{t.name}</MenuItem>
                    ))}
                  </TextField>
                </FormControl>

                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    id="searchStatus"
                    name="searchStatus"
                    margin="normal"
                    label={<IntlMessages id="invoices.searchStatus" />}
                    select
                    defaultValue=""
                    value={this.state.searchStatus}
                    onChange={event => this.handleChange('searchStatus', event.target.value)}>
                    <MenuItem key="0" value="0">
                      <IntlMessages id="invoice.statusAll" />
                    </MenuItem>
                    <MenuItem key="1" value="1">
                      <IntlMessages id="invoice.statusPaid" />
                    </MenuItem>
                    <MenuItem key="2" value="2">
                      <IntlMessages id="invoice.statusUnPaid" />
                    </MenuItem>
                    <MenuItem key="3" value="3">
                      <IntlMessages id="invoice.statusCancelled" />
                    </MenuItem>
                  </TextField>
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    required
                    id="searchClientName"
                    name="searchClientName"
                    label={<IntlMessages id="invoice.clientName" />}
                    margin="normal"
                    defaultValue=""
                    onChange={event => this.handleChange('searchClientName', event.target.value)}
                  />
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date1"
                    name="date1"
                    autoOk="true"
                    label={<IntlMessages id="bookings.fromDate" />}
                    value={this.state.date1}
                    onChange={date => {
                      this.setState({ date1: date }, () => {
                        this.checkDates();
                      });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date2"
                    name="date2"
                    autoOk="true"
                    label={<IntlMessages id="bookings.toDate" />}
                    value={this.state.date2}
                    onChange={date => {
                      this.setState({ date2: date });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
              </Box>
              <Box className={classes.cardContentInner2}>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('filter')}>
                    <IntlMessages id="bookings.filter" />
                  </Button>
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('download')}>
                    <IntlMessages id="invoices.downloadCSV" />
                  </Button>
                </FormControl>
              </Box>
            </>
          )}
          <PerfectScrollbar className={classes.scrollbarRoot}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <StyledTableRow>
                    {columns.map(column => (
                      <StyledTableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </TableHead>

                <TableBody>
                  {this.state.userActivities
                    .slice(
                      this.state.page * this.state.rowsPerPage,
                      this.state.page * this.state.rowsPerPage + this.state.rowsPerPage,
                    )
                    .map(row => {
                      var rowColor = '',
                        rowColor2 = '#000000';
                      /*var x = 1;
                      if (row['status'] == 1) x = 0;
                      if (row['cancel_id'] != null) x = 2;*/
                      rowColor = getColor(row['mystatus']);
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          id={row.id}
                          //style={{ backgroundColor: rowColor }}
                          onClick={() => this.eventClick(row['id'], row['ID'], row['mystatus'])}>
                          {columns.map(column => {
                            const value = row[column.id];
                            return (
                              <StyledTableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                              </StyledTableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={this.state.userActivities.length}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </PerfectScrollbar>
        </Paper>

        <Invoice
          mode={this.state.mode}
          resId={this.state.selInvoiceId}
          resTitle={this.state.selInvoiceTitle}
          open={this.state.viewInvoiceVisible}
          doRefresh={this.doRefresh}
          status={this.state.setStatus}
          viewMode={0}
          setState={p => {
            this.setState(p);
          }}
        />
      </PageContainer>
    );
  }
}

Invoices.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};
Invoices.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(Invoices)));
